/**
 * @fileoverview AdjustmentFields Component
 *
 * Handles the adjustment-specific form with from/to category selection.
 * Provides labeled dropdowns for selecting source and destination categories
 * for budget transfers.
 *
 * @module components/TransactionForm/AdjustmentFields
 */
import styles from './AdjustmentFields.module.css';

function AdjustmentFields({
    adjustmentFromCategory,
    adjustmentToCategory,
    categories,
    errors,
    onFieldChange,
    clearError
}) {
    const handleFromCategoryChange = (value) => {
        onFieldChange('adjustmentFromCategory', value);
        clearError('adjustmentFromCategory');
        clearError('adjustmentCategories');
    };

    const handleToCategoryChange = (value) => {
        onFieldChange('adjustmentToCategory', value);
        clearError('adjustmentToCategory');
        clearError('adjustmentCategories');
    };

    return (
        <div className={styles.adjustmentContainer}>
            <h4 className={styles.heading}>Transfer Between Categories:</h4>
            <div className={styles.fieldsRow}>
                <div className={styles.fieldGroup}>
                    <label className={styles.fieldLabel}>From:</label>
                    <select
                        value={adjustmentFromCategory}
                        onChange={(e) => handleFromCategoryChange(e.target.value)}
                        className={`${styles.categorySelect} ${(errors.adjustmentFromCategory || errors.adjustmentCategories) ? styles.selectError : ''}`}
                    >
                        <option value="">Select Category</option>
                        {categories.filter(cat => cat !== adjustmentToCategory).map(cat => (
                            <option key={cat} value={cat}>{cat}</option>
                        ))}
                    </select>
                </div>

                <div className={styles.fieldGroup}>
                    <label className={styles.fieldLabel}>To:</label>
                    <select
                        value={adjustmentToCategory}
                        onChange={(e) => handleToCategoryChange(e.target.value)}
                        className={`${styles.categorySelect} ${(errors.adjustmentToCategory || errors.adjustmentCategories) ? styles.selectError : ''}`}
                    >
                        <option value="">Select Category</option>
                        {categories.filter(cat => cat !== adjustmentFromCategory).map(cat => (
                            <option key={cat} value={cat}>{cat}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}

export default AdjustmentFields;
